module.exports = __webpack_public_path__ + "media/images/pic/hero/video-top-e887bb233399386bf4d1d376043ffc5a.svg";